// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-panel {
    /* z-index: 9999 !important; */
    /* position: fixed; */
    /* top: 0px; */
    /* left: 0px; */
    background-color: var(--headerBackground);
    color: var(--headerColor);
    height: 36px;
    width: 100%;
    text-align: center;
    line-height: 32px;
    /* border-top: 1px solid var(--headerBorder); */
    border-bottom: 1px solid var(--headerBorder);
}

.work-panel {
    position: absolute;
    top: 37px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    background-color: var(--workPanelBackground);
    min-width: 930px;
}

.text-content {
    overflow-y: auto;
    overflow-x: auto;
    padding-left: 10px;
    color: rgb(172, 172, 172);
    font-family: "Segoe UI Symbol", "Roboto-Regular", "Helvetica Neue", sans-serif;
    font-size: 12px;
}

.mat-row {
    min-height: 34px;
    height: 34px;
    border-bottom-color: rgba(0, 0, 0, 0.06);
}

.mat-cell {
    font-size: 13px;
}

.mat-header-row {
    top: 0;
    position: sticky;
    z-index: 1;
}
.mat-header-cell {
    font-size: 13px;
}

.my-header-filter ::ng-deep .mat-sort-header-button {
    display: block;
    text-align: left;
    margin-top: 5px;
}

.my-header-filter ::ng-deep .mat-sort-header-arrow {
    /* color: white; */
    top: -12px;
    right: 20px;
}

.my-header-filter-input {
    display: block;
    margin-top: 4px;
    margin-bottom: 6px;
    /* color: white; */
    padding: 3px 1px 3px 2px;
    border-radius: 2px;
    border: 1px solid var(--formInputBackground);
    background-color: var(--formInputBackground);
    color: var(--formInputColor);
}

.my-header-filter-input:focus {
    padding: 3px 1px 3px 2px;
    border: 1px solid var(--formInputBorderFocus);
    background-color: var(--formInputBackgroundFocus);
}

.mat-column-ontime {
    overflow: visible;
    flex: 0 0 160px;
}

.mat-column-type {
    flex: 0 0 100px;
}

.mat-column-source {
    flex: 1 1 300px;
}

.mat-column-text {
    flex: 3 1 400px;
}

.logs-selector {
    position: absolute;
    top: 50px;
    right: 40px;
    z-index: 999;
    padding: 5px 7px;
    background-color: var(--toolboxBackground);
    color: var(--toolboxColor);
    box-shadow: 0px 1px 3px 0px #000;
}
`, "",{"version":3,"sources":["webpack://./src/app/logs-view/logs-view.component.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,qBAAqB;IACrB,cAAc;IACd,eAAe;IACf,yCAAyC;IACzC,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,+CAA+C;IAC/C,4CAA4C;AAChD;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,UAAU;IACV,WAAW;IACX,4CAA4C;IAC5C,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,8EAA8E;IAC9E,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,wCAAwC;AAC5C;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,MAAM;IACN,gBAAgB;IAChB,UAAU;AACd;AACA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;AACf;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,wBAAwB;IACxB,kBAAkB;IAClB,4CAA4C;IAC5C,4CAA4C;IAC5C,4BAA4B;AAChC;;AAEA;IACI,wBAAwB;IACxB,6CAA6C;IAC7C,iDAAiD;AACrD;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,0CAA0C;IAC1C,0BAA0B;IAC1B,gCAAgC;AACpC","sourcesContent":[".header-panel {\n    /* z-index: 9999 !important; */\n    /* position: fixed; */\n    /* top: 0px; */\n    /* left: 0px; */\n    background-color: var(--headerBackground);\n    color: var(--headerColor);\n    height: 36px;\n    width: 100%;\n    text-align: center;\n    line-height: 32px;\n    /* border-top: 1px solid var(--headerBorder); */\n    border-bottom: 1px solid var(--headerBorder);\n}\n\n.work-panel {\n    position: absolute;\n    top: 37px;\n    left: 0px;\n    right: 0px;\n    bottom: 0px;\n    background-color: var(--workPanelBackground);\n    min-width: 930px;\n}\n\n.text-content {\n    overflow-y: auto;\n    overflow-x: auto;\n    padding-left: 10px;\n    color: rgb(172, 172, 172);\n    font-family: \"Segoe UI Symbol\", \"Roboto-Regular\", \"Helvetica Neue\", sans-serif;\n    font-size: 12px;\n}\n\n.mat-row {\n    min-height: 34px;\n    height: 34px;\n    border-bottom-color: rgba(0, 0, 0, 0.06);\n}\n\n.mat-cell {\n    font-size: 13px;\n}\n\n.mat-header-row {\n    top: 0;\n    position: sticky;\n    z-index: 1;\n}\n.mat-header-cell {\n    font-size: 13px;\n}\n\n.my-header-filter ::ng-deep .mat-sort-header-button {\n    display: block;\n    text-align: left;\n    margin-top: 5px;\n}\n\n.my-header-filter ::ng-deep .mat-sort-header-arrow {\n    /* color: white; */\n    top: -12px;\n    right: 20px;\n}\n\n.my-header-filter-input {\n    display: block;\n    margin-top: 4px;\n    margin-bottom: 6px;\n    /* color: white; */\n    padding: 3px 1px 3px 2px;\n    border-radius: 2px;\n    border: 1px solid var(--formInputBackground);\n    background-color: var(--formInputBackground);\n    color: var(--formInputColor);\n}\n\n.my-header-filter-input:focus {\n    padding: 3px 1px 3px 2px;\n    border: 1px solid var(--formInputBorderFocus);\n    background-color: var(--formInputBackgroundFocus);\n}\n\n.mat-column-ontime {\n    overflow: visible;\n    flex: 0 0 160px;\n}\n\n.mat-column-type {\n    flex: 0 0 100px;\n}\n\n.mat-column-source {\n    flex: 1 1 300px;\n}\n\n.mat-column-text {\n    flex: 3 1 400px;\n}\n\n.logs-selector {\n    position: absolute;\n    top: 50px;\n    right: 40px;\n    z-index: 999;\n    padding: 5px 7px;\n    background-color: var(--toolboxBackground);\n    color: var(--toolboxColor);\n    box-shadow: 0px 1px 3px 0px #000;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
